import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import * as materialStyles from '../../../constants/materialstyle';

import {isAdmin, logout} from '../../../utils/auth';
import * as authActionCreators from '../../../actions/auth';

import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import NavigationMenu from 'material-ui/svg-icons/navigation/menu';


class HeaderMenu extends React.Component {
  
  static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  transferNav() {
    this.context.router.push('/transfers');
  }

  pendingNav() {
    this.context.router.push('/pending');
  }

  historyNav() {
    this.context.router.push('/closed');
  }

  logoutUser() {
    logout();
    this.props.authClear();
    this.context.router.push('/login');
  }

  transferLabel() {
    return isAdmin() ? "Open Transfers" : "Outgoing Transfers";
  }

  pendingLabel() {
    return isAdmin() ? "Pending Transfers" : "Incoming Transfers";
  }

  closedLabel() {
    return "Closed Transfers";
  }

  render() {

    console.log(this.props.user.user);

    return <IconMenu
      iconButtonElement={
        <IconButton iconStyle={{width: '30px', height: '30px'}}><NavigationMenu color='#FFFFFF' /></IconButton>
      }
      targetOrigin={{horizontal: 'right', vertical: 'top'}}
      anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}>
      <MenuItem 
        primaryText={this.transferLabel()}
        hoverColor='#0000FF'
        onClick={::this.transferNav} />
      <MenuItem 
        primaryText={this.pendingLabel()}
        hoverColor='#0000FF'
        onClick={::this.pendingNav} />
      <MenuItem 
        primaryText={this.closedLabel()}
        hoverColor='#0000FF'
        onClick={::this.historyNav} />
      <MenuItem 
        primaryText="Log out"
        hoverColor='#0000FF'
        onClick={::this.logoutUser} />
      {this.props.user.user ?
        <div className='headerMenuLoggedEmail'>Logged in as: {this.props.user.user.email}</div> :
        null
      }
    </IconMenu>
  }
}
export default HeaderMenu;

function mapStateToProps(state) {
  return {
    auth: state.auth,
    user: state.user
  };
}

export const HeaderMenuContainer = connect(
  mapStateToProps,
  authActionCreators
)(HeaderMenu);